var _ellipse, _g, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 140,
    viewBox: "0 0 228 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 114,
    cy: 124,
    rx: 114,
    ry: 9,
    fill: "#DEDEDE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1628_111231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.7056 86.8246C24.1271 92.7157 28.3048 94.3444 31.473 95.1933L164.268 130.775C170.834 132.535 172.612 129.528 173.447 126.412L194.977 46.0581C195.81 42.9494 195.509 39.2649 189.238 37.5847L56.4435 2.00245C50.382 0.378277 48.0693 3.36233 47.2363 6.47097L25.7056 86.8246Z",
    fill: "#54565A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.361 101.974C101.484 101.515 100.941 101.196 100.941 101.196C95.2136 98.0393 90.5809 93.2534 87.6569 87.4732C83.4808 79.7488 80.2821 71.5572 78.1331 63.0831C77.8627 61.3836 78.8599 61.4868 78.8599 61.4868C83.1583 60.9892 87.2066 59.2768 90.5159 56.5564C93.8252 53.836 96.2541 50.224 97.5094 46.1563C101.387 31.6842 88.5522 23.64 75.9655 20.2674C71.1968 18.9897 69.5194 18.9459 64.5537 17.6153C58.7631 16.0637 55.4254 14.7637 54.5184 14.5207C54.332 14.4805 54.1397 14.4775 53.9528 14.5119C53.7659 14.5462 53.5883 14.6172 53.4305 14.7207C53.2728 14.8241 53.138 14.9579 53.0343 15.1141C52.9306 15.2703 52.8601 15.4456 52.8269 15.6298C51.8882 19.1331 61.6083 15.3933 58.4793 27.0708L46 73.6441C43.1116 84.4237 36.1787 79.3377 35.4741 81.9672C35.2443 82.8249 36.1801 83.4036 36.767 83.5609C39.6397 84.3306 43.0242 84.8318 47.6822 86.0799C53.5508 87.6524 54.9309 88.4279 58.3002 89.3307C60.7626 89.9905 61.3003 89.6253 61.4848 88.9367C62.3652 85.6509 50.6027 87.9026 54.3553 73.8976L67.5122 24.7955C68.2966 21.8681 70.4676 22.4498 73.6317 23.2976C85.0652 26.3612 92.4342 34.9908 89.4596 46.8305C88.9532 48.9176 88.0166 50.8765 86.7076 52.5864C85.3985 54.2963 83.7448 55.7211 81.8484 56.773C79.9519 57.8248 77.8529 58.4814 75.6807 58.7023C73.5084 58.9232 71.309 58.7037 69.2179 58.0573C68.0054 57.7807 66.8204 57.3953 65.6776 56.9059C65.2098 56.7805 64.6461 56.8323 64.4691 57.4927C64.2231 58.4108 64.8347 59.0667 65.634 59.5311C68.105 61.0103 69.9086 63.3661 70.6679 66.1065C74.5262 78.7931 77.7584 97.0995 95.1467 101.759C101.627 103.495 101.189 102.566 101.346 101.983",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.78 87.8434L194.92 46.2714C195.783 43.05 195.48 39.2571 188.991 37.5186L189.02 37.5263L176.09 85.7827L183.78 87.8434Z",
    fill: "#F32735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.269 86.0206L176.583 83.9609L172.977 97.4183L180.663 99.4779L184.269 86.0206Z",
    fill: "#FCBD1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.508 126.185L181.017 98.1591L173.33 96.0995L164.058 130.705L164.029 130.698C170.788 132.509 172.644 129.407 173.508 126.185Z",
    fill: "#8F4899"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M181.435 24.0851L160.358 62.4084C159.965 63.0959 159.769 63.8816 159.769 64.6476C159.769 67.2209 161.851 69.303 164.424 69.303H206.577C207.363 69.303 208.129 69.1066 208.817 68.7334C209.897 68.1441 210.702 67.1423 211.036 65.9637C211.39 64.7655 211.233 63.5084 210.644 62.428L189.567 24.0851C189.135 23.3191 188.506 22.6905 187.74 22.2584C185.501 21.0209 182.672 21.8459 181.435 24.0851Z",
    fill: "#FFDD75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M210.644 62.4134L189.568 24.0902C189.136 23.3241 188.507 22.6955 187.741 22.2634C186.189 21.4188 184.382 21.5563 182.987 22.4402C183.616 22.8527 184.146 23.4027 184.519 24.0705L205.596 62.3938C206.186 63.4741 206.343 64.7313 205.989 65.9295C205.636 67.1277 204.85 68.1098 203.769 68.6991C203.082 69.0723 202.316 69.2688 201.53 69.2688H206.578C207.364 69.2688 208.13 69.0723 208.818 68.6991C209.898 68.1098 210.703 67.108 211.037 65.9295C211.391 64.7705 211.253 63.5134 210.644 62.4134Z",
    fill: "#FFCC00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M206.596 71.0826H164.423C160.888 71.0826 158 68.1951 158 64.6594C158 63.579 158.275 62.5183 158.786 61.5755L179.882 23.2326C181.591 20.129 185.5 19.0094 188.604 20.7183C189.664 21.3076 190.529 22.1719 191.118 23.2326L212.195 61.5558C213.02 63.0683 213.216 64.7969 212.745 66.4469C212.273 68.0969 211.173 69.4523 209.68 70.2773C208.737 70.8076 207.657 71.0826 206.596 71.0826ZM181.434 24.0969L160.357 62.4201C159.964 63.1076 159.768 63.8737 159.768 64.6594C159.768 67.2326 161.85 69.3147 164.423 69.3147H206.577C207.362 69.3147 208.129 69.1183 208.816 68.7451C209.896 68.1558 210.702 67.154 211.036 65.9755C211.389 64.7772 211.232 63.5201 210.643 62.4397L189.566 24.0969C189.134 23.3308 188.505 22.7023 187.739 22.2701C185.5 21.0326 182.671 21.838 181.434 24.0969Z",
    fill: "#4A0E63"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M185.499 58.1299C184.517 58.1299 183.731 58.9156 183.731 59.8977C183.731 60.8799 184.517 61.6656 185.499 61.6656C186.481 61.6656 187.267 60.8799 187.267 59.8977C187.267 58.9156 186.481 58.1299 185.499 58.1299Z",
    fill: "#4A0E63"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M185.5 54.4399C185.009 54.4399 184.616 54.047 184.616 53.556V35.9953C184.616 35.5042 185.009 35.1113 185.5 35.1113C185.991 35.1113 186.384 35.5042 186.384 35.9953V53.556C186.384 54.047 185.991 54.4399 185.5 54.4399Z",
    fill: "#4A0E63"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1628_111231",
    x: 20,
    y: 0,
    width: 180.712,
    height: 140.778,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1628_111231"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1628_111231",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardError);
export default __webpack_public_path__ + "static/media/card-error.f330e4219c88d35414e9332054d755d1.svg";
export { ForwardRef as ReactComponent };